'use client'

import React from 'react'

import { Footer, Header, Main, PageWrapper } from 'Components/Blocks'
import {
  CompanyHeroSection,
  CompanyHistorySection,
  MeetUsInSection,
  WhatWeStandForSection,
  WhoWeAreSection,
} from 'Components/Sections'

function CompanyPage() {
  return (
    <PageWrapper>
      <Header />

      <Main>
        <CompanyHeroSection pb={17} pt={[144, 144, 160, 160, 92]} />

        <WhoWeAreSection py={17} />

        <WhatWeStandForSection py={17} />

        <CompanyHistorySection py={17} />

        <MeetUsInSection py={17} />
      </Main>

      <Footer />
    </PageWrapper>
  )
}

export default CompanyPage
